module.exports = __webpack_public_path__ + "media/images/flags/4x3/mng-9e1ee95dfe7a37c32428f4130afb853e.svg";